import { cn } from "@/lib/utils";
import { formatDateTime } from "@/lib/date-formatters";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const statusColors: Record<string, string> = {
  new: "bg-blue-50 text-blue-700",
  processing: "bg-yellow-50 text-yellow-700",
  fulfilled: "bg-emerald-50 text-emerald-700",
  cancelled: "bg-red-50 text-red-700",
};

const statusLabels: Record<string, string> = {
  new: "Nova",
  processing: "U obradi",
  fulfilled: "Isporučena",
  cancelled: "Otkazana",
};

interface OrderStatusCardProps {
  status: string;
  createdAt: string;
  orderId: number;
  onChangeStatus: (status: string) => void;
  isPending: boolean;
}

export default function OrderStatusCard({
  status,
  createdAt,
  orderId,
  onChangeStatus,
  isPending,
}: OrderStatusCardProps) {
  return (
    <div className="bg-white rounded-xl border border-border/60 overflow-hidden">
      <div className="px-5 py-3 border-b border-border/40">
        <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Status</h3>
      </div>
      <div className="p-5 space-y-4">
        <div>
          <p className="text-xs text-muted-foreground mb-2">
            {formatDateTime(createdAt)}
          </p>
          <span className={cn("text-xs font-medium px-2.5 py-1 rounded-full", statusColors[status])}>
            {statusLabels[status]}
          </span>
        </div>

        <div className="space-y-2">
          <label className="text-xs font-medium text-muted-foreground block">Promijeni status</label>
          <Select
            value={status}
            onValueChange={(value) => {
              if (value === status) return;
              if (value === "cancelled") {
                if (!confirm(`Otkazati narudžbu #${orderId}?`)) return;
              }
              onChangeStatus(value);
            }}
            disabled={isPending}
          >
            <SelectTrigger className="w-full h-9 rounded-lg text-sm">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {(["new", "processing", "fulfilled", "cancelled"] as const).map((s) => (
                <SelectItem key={s} value={s}>
                  {statusLabels[s]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
